import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';

@Component({
  selector: 'app-notification-dialog',
  templateUrl: './notification-dialog.component.html',
  styleUrls: ['./notification-dialog.component.scss'],
})
export class NotificationDialogComponent {
  title?: string;
  descriptionText?: string;
  descriptionFaClass?: string;
  descriptionFaColor?: string;
  orientation: DialogOrientation;
  confirmText?: string;
  confirmFaClass?: string;
  confirmFaColor?: string;
  declineText?: string;
  declineFaClass?: string;
  declineFaColor?: string;
  hideClose: boolean;
  buttonAlignment: DialogButtonAlignment;
  closeButton: boolean;
  iconDescriptionAlign: boolean;
  DialogButtonAlignment = DialogButtonAlignment;
  DialogOrientation = DialogOrientation;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<NotificationDialogComponent>,
    public overlayLoader: OverlayLoaderService
  ) {
    this.overlayLoader.isLoading = false;

    this.title = this.data.title;
    this.descriptionText = this.data.descriptionText;
    this.descriptionFaClass = this.data.descriptionFaClass;
    this.descriptionFaColor = this.data.descriptionFaColor;
    this.orientation = this.data.orientation ?? DialogOrientation.column;
    this.confirmText = this.data.confirmText;
    this.confirmFaClass = this.data.confirmFaClass;
    this.confirmFaColor = this.data.confirmFaColor;
    this.declineText = this.data.declineText;
    this.declineFaClass = this.data.declineFaClass;
    this.declineFaColor = this.data.declineFaColor;
    this.hideClose = this.data.hideClose ?? false;
    this.closeButton = this.data.closeButton ?? false;
    this.buttonAlignment = this.data.buttonAlignment ?? DialogButtonAlignment.center;
    this.iconDescriptionAlign = this.data.iconDescriptionAlign ?? false;
  }

  confirm(event: Event) {
    this.dialogRef.close(true);
    event.stopPropagation();
  }

  decline(event: Event) {
    this.dialogRef.close(false);
    event.stopPropagation();
  }
}

export interface DialogData {
  title?: string;
  descriptionText?: string;
  descriptionFaClass?: string;
  descriptionFaColor?: string;
  orientation?: DialogOrientation;
  confirmText?: string;
  confirmFaClass?: string;
  confirmFaColor?: string;
  declineText?: string;
  declineFaClass?: string;
  declineFaColor?: string;
  hideClose?: boolean;
  buttonAlignment?: DialogButtonAlignment;
  closeButton?: boolean;
  iconDescriptionAlign?: boolean;
}

export enum DialogButtonAlignment {
  center = 'center',
  end = 'end',
}

export enum DialogOrientation {
  row = 'row',
  column = 'column',
}
